import { getLeaveAction } from '@components/Dashboard/utils'
import type { ID } from '@octopus-do/octopus-project-core'
import { Button } from '@octopus-do/octopus-storybook'
import { SubscriptionCancelledPic } from '@octopus-do/octopus-storybook/icons'
import type { DashboardFeatures } from '@store/reducers/dashboard/types'
import { UpgradePlanActions } from '@store/reducers/upgradePlan'
import type React from 'react'
import { useDispatch } from 'react-redux'

import css from './styles.module.css'

interface Props {
  features: DashboardFeatures[]
  id: ID
}

const UpgradeAction = UpgradePlanActions.updatePayment({
  planId: 'plan_teamperseat2',
  planType: 'monthly',
})

export const ExpiredView: React.FC<Props> = ({ features, id }) => {
  const dispatch = useDispatch()
  const resubscribe = features.includes('resubscribe_button')
  const leave = features.includes('leave_team')
  const onResubscribe = () => dispatch(UpgradeAction)
  const onLeave = () => dispatch(getLeaveAction(id))

  return (
    <div className={css.expired_view}>
      <SubscriptionCancelledPic className={css.expired_view_icon} />
      <div className={css.expired_view_text}>
        This team account is suspended.Please reactivate subscription.
      </div>
      {resubscribe && (
        <Button
          priority="outline"
          size="medium"
          label="Resubscribe"
          onClick={onResubscribe}
        />
      )}
      {leave && (
        <Button
          priority="outline"
          size="medium"
          label="Leave team"
          onClick={onLeave}
        />
      )}
    </div>
  )
}
